import ROUTES_PATH, { PAGES_KEYS, SETTINGS_PAGES, SYSTEMS_PAGES } from "constants/pages.constant";

export const getSystemsPagePath = (sysId, page) => `${ROUTES_PATH.SYSTEMS.replace(":systemId", sysId)}${SYSTEMS_PAGES[page]}`;
export const getSettingsPagePath = page => `${ROUTES_PATH.SETTINGS}${SETTINGS_PAGES[page]}`;

export const getDashboardsPagePath = sysId => getSystemsPagePath(sysId, PAGES_KEYS.DASHBOARDS);
export const getNotificationSettingsPath = () => getSettingsPagePath(PAGES_KEYS.NOTIFICATION);
export const getAlarmsPagePath = sysId => getSystemsPagePath(sysId, PAGES_KEYS.ALARMS);
export const getInsightsPagePath = sysID => getSystemsPagePath(sysID, PAGES_KEYS.INSIGHTS);
export const getBaselinePagePath = sysId => getSystemsPagePath(sysId, PAGES_KEYS.BASELINES);
